<template>
  <div
    class="item"
    :class="getClasses"
    @click="onClick"
  >
    {{ label }}
  </div>
</template>

<script>
export default {
  name: 'AppMenuItem',
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    label: {
      type: [String, Number],
      default: null
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  emits: {
    click: null
  },
  computed: {
    getClasses () {
      return {
        item_active: this.isActive
      }
    }
  },
  methods: {
    onClick () {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
$brand-color:                 #FF7A00 !default;

.item {
  padding: 16px 22px;
  font-weight: bold;
  font-size: 18px;
  line-height: 20px;
  color: #DBDBDC;
  border-bottom: 2px solid transparent;
  cursor: pointer;

  &_active {
    border-bottom: 2px solid $brand-color;
    color: $brand-color;
  }
}
</style>
